import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080', // Default to localhost for development
  withCredentials: true, // Automatically send cookies with requests
});

export default instance;
